export default angular.module('eventix.common.services.syncHttp', []).factory('syncHttp', function($q) {
    return function syncHttp(method, url, data, headers) {
        /** We need to set-up a synchronous request, but mimick the Angular $http interface */
        return $q(function(resolve, reject) {
            let xhr = new XMLHttpRequest();
            xhr.open(method.toUpperCase(), url, false);
            xhr.onreadystatechange = function() {
                if (this.readyState !== 4) return;
                let headers = this.getAllResponseHeaders() || '';
                headers = _.map(headers.split('\u000d\u000a'), line => {
                    var index = line.indexOf('\u003a\u0020');
                    if (index > 0)
                        return [line.substring(0, index), line.substring(index + 2)];
                    return [line, ''];
                });
                let response = {
                    data: ('response' in this) ? this.response : this.responseText,
                    headers: _.fromPairs(headers),
                    status: this.status,
                    statusText: this.statusText || '',
                    config: {
                        url: url,
                        method: method
                    }
                };
                if (this.status >= 200 && this.status < 400)
                    resolve(response);
                else
                    reject(response);
            };
            let requestError = () => reject({ data: null, headers: null, status: -1, statusText: '', config: { url: url, method: method } });
            _.forEach(headers, (value, key) => {
                xhr.setRequestHeader(key, value);
            });
            xhr.onerror = requestError;
            xhr.onabort = requestError;
            xhr.ontimeout = requestError;
            xhr.send(data);
        });
    };
}).name;
